
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/renting/[brand]/[model]",
      function () {
        return require("private-next-pages/es/renting/[brand]/[model]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/renting/[brand]/[model]"])
      });
    }
  